import axios from "axios";
import configuration from "@/utils/configuration";

export const notificationService = {
  getUserNotification(params) {
    return axios.get(`${configuration.notificationUrl}/user`,{
      withCredentials: true,
      params:params
    });
  },
  getNotificationDetail(notificationId) {
    return axios.get(`${configuration.notificationUrl}/detail`,{
      withCredentials: true,
      params:{notification_id : notificationId}
    });
  },
  patchIsAllowNotiRelation(relationshipId, notificationFlag) {
    return axios.patch(`${configuration.notificationUrl}/relationship`,null, {
      withCredentials: true,
      params: {
            relationship_id: relationshipId,
            notification_flag: notificationFlag,
      },
    });
  },
  readNotification(notificationId) {
    return axios.patch(`${configuration.notificationUrl}/read`, null, {
      withCredentials: true,
      params: { notification_id: notificationId },
    });
  },
  readAllNotification() {
    return axios.patch(`${configuration.notificationUrl}/read-all`,null, {
      withCredentials: true,
    });
  },
};
